import React from "react";
import { Form, Input, Button, Icon } from "antd";
import ReactToPrint from "react-to-print";

const OrderNumber = ({
  form,
  disabled,
  handleClickShowAllFields,
  componentRef
}) => {
  const { getFieldDecorator } = form;

  return (
    <div className="offer-card__item">
      <span className="label">Номер заказа:</span>
      <Form.Item>
        {getFieldDecorator("number")(
          <Input style={{ width: 368 }} disabled={disabled} />
        )}
      </Form.Item>
      <span className="extra-label">
        <span className="show-map">
          <ReactToPrint
            content={() => componentRef}
            bodyClass={"offer-card__form"}
            onBeforeGetContent={() => {
              handleClickShowAllFields(true);
            }}
            trigger={() => {
              return (
                <Button
                  type="link"
                  className="print-order"
                  id="print-order-btn"
                >
                  Распечатать заказ <Icon type="printer" />
                </Button>
              );
            }}
          />
        </span>
      </span>
    </div>
  );
};

export default OrderNumber;
